import {ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnChanges, Output} from '@angular/core';
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {ClickOutsideDirective} from "../../../shared/directives/click-outside.directive";
import {RecordTableAction} from "../../types/record-table-action.types";
import {UtilityService} from "../../services/utility.service";
import {ActionDropdownMenuService} from "./services/action-dropdown-menu.service";
import {relevantAction} from "./configs/action-dropdown-menu-config";
import {smoothShowHideHeight} from "../../../shared/animations/smoothShowHideAnimations";

@Component({
  selector: 'app-action-dropdown-menu',
  imports: [
    MatButton,
    MatIconButton,
    MatIcon,
    ClickOutsideDirective
  ],
  templateUrl: './action-dropdown-menu.component.html',
  styleUrl: './action-dropdown-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [smoothShowHideHeight]
})
export class ActionDropdownMenuComponent implements OnChanges {
  @Input() actionsList: Array<RecordTableAction> = [];
  @Output() actionSelected: EventEmitter<RecordTableAction> = new EventEmitter<RecordTableAction>();

  private utilityService: UtilityService = inject(UtilityService);
  private actionDropdownMenuService: ActionDropdownMenuService = inject(ActionDropdownMenuService);

  public isContentShowing: boolean = false;
  public hasRelevantAction: boolean = true;

  public ngOnChanges(): void {
    this.hasRelevantAction = this.utilityService.isArrayContainsAnyElementOfAnotherArray(this.actionsList, relevantAction);
  }

  public toggleContent(): void {
    this.isContentShowing = !this.isContentShowing;
  }

  public closeContent(): void {
    this.isContentShowing = false;
  }

  public handleActionClick(action: RecordTableAction): void {
    this.closeContent();
    this.actionSelected.emit(action);
  }

  public getLabelByAction(action: RecordTableAction): string {
    return this.actionDropdownMenuService.getLabelByAction(action);
  }
}
